var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_box--gray_235"},[_c('div',{staticClass:"c_promo_list c_wrapper c_grid c_grid--2"},_vm._l((_vm.data),function(promo,index){return _c('Promo',{key:index,attrs:{"promo":promo}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }